<template>
  <main class="app-container">
    <div v-if="activity.id">
      <div class="ch-header-paper white">
        <div class="top">
          <div class="info">
            <h2>{{activity.name}}</h2>
            <p>
              <img class="icon" src="../assets/images/icon_age.png" alt="">
              年龄：{{activity.age_period}}
            </p>
            <p>
              <img class="icon" src="../assets/images/icon_clock.png" alt="">
              时间：{{activity.time}}
            </p>
            <p>
              <img class="icon" src="../assets/images/icon_leaf.png" alt="">
              材料：{{activity.items}}
            </p>
            <p>
              <img class="icon" src="../assets/images/icon_skill.png" alt="">
              技能：{{activity.skill}}
            </p>
          </div>
        </div>
        <div class="bottom"></div>
      </div>


        <div class="content">
          <h4 class="title">活动内容</h4>
          <div class="rich-text ck-content" v-html="activity.content"></div>
          <h4 class="title">为什么这项活动对孩子们很重要？</h4>
          <div class="rich-text"><p>{{activity.why_important}}</p></div>
      </div>
    </div>
  </main>
</template>

<script>


export default {
  name: "home",
  components: {

  },
    data() {
        return {
            activity:{id:null},
        }
    },
    created() {
        console.log(this.$route);
        const {id} = this.$route.params;
        if(id) {
            this.loadData(id);
        }


    },
    methods: {
        loadData(id) {
            this.$toast.loading("加载中...");
            this.$http.get(`activities/${id}`)
                .then(({data}) => {
                    this.$toast.hide();
                    this.activity = data;
                })
                .catch(err => {
                    console.log(err);
                });
        },
    }
};
</script>


<style lang="scss" scoped>
.info {
  text-align: center;
  padding: 0 20px;
  h2 {
    font-size: 90px;
    text-align: center;
    /*margin-top: 40px;*/
    margin-bottom: 50px;
  }
  p {
    font-size: 24px;
    color: #9b9b9b;
    padding-bottom: 20px;

    .icon {
      width: auto;
      height: 36px;
      margin-right: 10px;
      vertical-align: middle;
    }
  }
}

.content {
  padding: 0 30px 20px;

  .title {
    font-weight: 600;
    font-size: 40px;
    margin-top: 75px;
    margin-bottom: 20px;
  }
}
</style>

